export default {
  install: function (Vue) {
    const formatBytes = (bytes = 0, decimals = 0) => {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }

    const formatFileExtensions = (fileTypes) => {
      return fileTypes.split(/[a-z]*\//).filter(Boolean).map(item => `.${item}`).join('')
    }

    Object.defineProperties(Vue.prototype, {
      '$formatBytes': {
        get () {
          return formatBytes
        }
      },
      '$formatFileExtensions': {
        get () {
          return formatFileExtensions
        }
      }
    })
  }
}
